import { ModalHandler } from '@app-velocity/ui';

import { HigherTierOnlyFeatureModalContent } from './components/HigherTierOnlyFeatureModalContent';

//@TODO - duplicate of apps/main-front
export const HigherTierOnlyFeatureModal = () => {
  return (
    <ModalHandler channel="users" id="higher-plan-feature-only">
      <HigherTierOnlyFeatureModalContent />
    </ModalHandler>
  );
};
